import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';
import ENV from '../config/environment';
import type IntlService from 'ember-intl/services/intl';
import type LoggingService from '../services/logger';

class HelpItem {
  @service declare intl: IntlService;
  topic = '';

  constructor(topic: string, intl: IntlService) {
    this.topic = topic;
    this.intl = intl;
  }
  get isFromUrl() {
    return this.topic[0] === '@';
  }
  get title() {
    let key = this.topic;
    if (this.topic[0] === '@') {
      key = this.topic.slice(1);
    }
    let result = this.intl.t(`help.${key}.title`, { htmlSafe: true });
    return result ? result : '';
  }
  get url() {
    if (this.topic[0] === '@') {
      return `${ENV.rootURL}helptext/${this.intl.locale}/${this.topic.slice(1)}.html`;
    } else {
      return '';
    }
  }
  get message() {
    let key = this.topic;
    if (this.topic[0] === '@') {
      return '';
    } else {
      let result = this.intl.t(`help.${key}.message`, { htmlSafe: true });
      return result ? result : '';
    }
  }
}

export default class HelpitemHelper extends Helper {
  @service declare intl: IntlService;
  @service declare logger: LoggingService;
  compute(params: string[]): HelpItem {
    let topic = '';
    if (params[0]) {
      topic = params[0];
    } else {
      this.logger.warn(`Help topic is undefined...`);
    }
    return new HelpItem(topic, this.intl);
  }
}
